import cognito from "@/configuration/cognito";
import router from "@/routes";

export default [
  {
    path: "/logout",
    redirect: "/signout",
  },
  {
    path: "/signout",
    beforeEnter: (route) => {
      cognito.signOut({
        onComplete: () => router.push(`/signin${route.query && route.query.cobrand ? `?cobrand=${route.query.cobrand}` : ""}`).catch(() => {}),
      });
      sessionStorage.clear();
    },
    meta: {
      preventInit: true,
    },
  },
];
